function InitStickyBar() {
    var $page = $('.product-details-region'),
        $fixedProduct = $(".x-product-details-sticky-bar"),
        $offsetContainer = $('.' + $fixedProduct.data('offset'), $page),
        scroll, ww, mobile;

    $('.js-select-size, .js-notify-button', $fixedProduct).click(function () {
        if (!($(window).outerWidth() < 768 && isTouch()))
            $("body,html").animate({ scrollTop: 0 }, $(window).scrollTop() / 2);
    });

    scroll = $(window).scrollTop();
    scroll > ($offsetContainer.offset().top - 100) ? $fixedProduct.addClass("visible") : $fixedProduct.removeClass("visible");

    $(window).scroll($.throttle(100, fixedScroll));

    function fixedScroll() {
        if ($(window).outerWidth() > 767) {
            scroll = $(window).scrollTop();
            scroll > ($offsetContainer.offset().top - 100) ? $fixedProduct.addClass("visible") : $fixedProduct.removeClass("visible");
            $('html').removeClass('hide-sticky-btns');
        } else if (isTouch() && $(window).outerWidth() < 768) {
            if ($(window).scrollTop() > ($offsetContainer.offset().top - 50)) {
                $fixedProduct.addClass('hidden');
                $('.x-product-details .x-product-details-availability-notification').addClass('hidden');
                $('html').removeClass('hide-sticky-btns');
            } else {
                $fixedProduct.removeClass('hidden');
                $('html').addClass('hide-sticky-btns');
            }
        }

    }

    /*reset*/
    $('html').removeClass('no-scroll');

    $(window).resize($.debounce(150, function () {
        ww = $(window).outerWidth();
        mobile = (ww < 767) ? true : false;

        if (isTouch() && !mobile) {
            if ($('.x-product-details-version-selector', $fixedProduct).hasClass('opened')) {
                $('.js-close-popup', $fixedProduct).trigger('click');
            }
        }       
    }));

    $('.open-dim-pop-up', $fixedProduct).click(function () {
        var parent = $(this).parent('.x-product-details-version-selector');
        if (parent.hasClass('opened')) {
            $('html').removeClass('no-scroll');
            $fixedProduct.removeClass('top-layer');
            parent.removeClass('opened').siblings().removeClass('shadow');
            $(this).removeClass('icon-minus').addClass('icon-plus');
        } else {
            $('html').addClass('no-scroll');
            if ($('.header-region').hasClass('sticky')) {
                $('.header-spacer').height(0);
                $('.header-region').removeClass('sticky');
            }
            $fixedProduct.addClass('top-layer');
            parent.addClass('opened').removeClass('shadow').siblings().removeClass('opened').addClass('shadow').children('.open-dim-pop-up').removeClass('icon-minus').addClass('icon-plus');
            $(this).removeClass('icon-plus').addClass('icon-minus');
        }
    });

    $('.js-close-popup', $fixedProduct).click(function () {
        var parent = $(this).closest('.x-product-details-version-selector');
        $fixedProduct.removeClass('top-layer');
        $('html').removeClass('no-scroll');
        parent.removeClass('opened').siblings().removeClass('shadow');
        parent.children('.open-dim-pop-up').removeClass('icon-minus').addClass('icon-plus');
    });

    $('.js-selector', $fixedProduct).click(function () {
        $('.js-close-popup', $fixedProduct).trigger('click');
    });
}
